import asBentoPage from 'common/bento/hoc/asBentoPage';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import ManageBeneficiariesPage from 'features/Onboarding/modules/Beneficiaries/pages/ManageBeneficiariesPage';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import CapitalDepositHeader from '../../components/CapitalDepositHeader';
import { GetBeneficiariesDataQuery } from '../../graphql/queries/getBeneficiariesData.gql';
import locales from './locales';

const BENEFICIARY_FAQ_LINK =
  'http://help.shine.fr/fr/articles/4305211-qu-est-ce-qu-un-beneficiaire-effectif';

interface ShareholdersBeneficiariesProps {
  onNext: () => void;
  onMoralBeneficiaryPress: () => void;
  isSaving: boolean;
  data: GetBeneficiariesDataQuery['viewer'];
  applicationType: ApplicationType.Standard | ApplicationType.CapitalDeposit;
  applicantType: ApplicantType.AccountHolder | ApplicantType.Mandatee;
}

const ShareholdersBeneficiaries = asBentoPage<ShareholdersBeneficiariesProps>(
  ({
    applicantType,
    applicationType,
    data,
    isSaving,
    Layout,
    onMoralBeneficiaryPress,
    onNext,
    onPrev,
  }) => {
    if (
      applicationType !== ApplicationType.Standard &&
      applicationType !== ApplicationType.CapitalDeposit
    ) {
      throw new Error(
        `Invalid application type for the ShareholdersBeneficiaryList: ${applicationType}`,
      );
    }

    const isCapitalDeposit = applicationType === ApplicationType.CapitalDeposit;
    const flow = isCapitalDeposit ? 'capDep' : 'standard';

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <ManageBeneficiariesPage
          applicantType={applicantType}
          applicationType={applicationType}
          data={data}
          header={
            isCapitalDeposit ? (
              <CapitalDepositHeader
                hideBody={
                  applicantType === ApplicantType.Mandatee &&
                  applicationType === ApplicationType.CapitalDeposit
                }
              />
            ) : (
              <Header
                description={locales.description[flow]}
                linkText={locales.beneficiaryFaqLink}
                linkUrl={BENEFICIARY_FAQ_LINK}
                title={locales.title[flow]}
              />
            )
          }
          includeShares={isCapitalDeposit}
          isExistingCompany={!isCapitalDeposit}
          isSaving={isSaving}
          onContinue={onNext}
          onMoralBeneficiaryPress={onMoralBeneficiaryPress}
        />
      </Layout>
    );
  },
);

export default ShareholdersBeneficiaries;
